const MyPlugin = {
  install: (Vue, options) => {
  // 注入组件选项
    Vue.mixin({
      methods: {
        openPage (pathObj, openNewWindow = false) {
          if (pathObj) {
            if (openNewWindow) {
              const { href } = this.$router.resolve(pathObj)
              window.open(href, '_blank')
            } else {
              this.$router.push(pathObj)
            }
          }
        }
      }
    })
  }
}

export {
  MyPlugin
}
